import { render, staticRenderFns } from "./submitStatus.vue?vue&type=template&id=6214b8fa"
import script from "./submitStatus.vue?vue&type=script&lang=js"
export * from "./submitStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports